import { forwardRef } from 'react';

export interface SectionHeaderProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  subtitleId?: string;
  actions?: React.ReactNode;
}

function cn(...parts: Array<string | undefined | false | null>): string {
  return parts.filter(Boolean).join(' ');
}

export const SectionHeader = forwardRef<HTMLDivElement, SectionHeaderProps>(function SectionHeader(
  { title, subtitle, subtitleId, actions, className, ...rest },
  ref,
) {
  return (
    <div ref={ref} className={cn('flex items-start justify-between gap-4', className)} {...rest}>
      <div className="min-w-0 space-y-1">
        <h3 className="text-base font-semibold tracking-tight text-[color:var(--color-text-primary)]">{title}</h3>
        {subtitle ? <p id={subtitleId} className="text-sm text-[color:var(--color-text-secondary)]">{subtitle}</p> : null}
      </div>
      {actions ? <div className="shrink-0">{actions}</div> : null}
    </div>
  );
});
